import styled from 'styled-components'

import { spacing } from '../../../../themes'

export const Container = styled.div`
  margin-top: auto;
  width: 100%;
  position: sticky;
  bottom: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(4, 4, 6)};
  background: rgba(238, 238, 238, 0.5);
`

export const Content = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.breakpoints.pc};
`
